import { HOST } from "../constants/HostConstants";

export const propertyDelete = async (
  property_id,
  user_id,
  { setProperties } = {}
) => {
  try {
const res = await fetch(`${HOST}/api/property/propertyDelete`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ property_id, user_id }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });

    let data;
    try {
      data = await res.json();
    } catch (e) {
      data = null;
    }
if (!res.ok) {
      const err = (data && data.error) || `Delete failed: ${res.status}`;
      if (setProperties && typeof setProperties === "function") {
        // no-op: keep previous properties
      }
      return { success: false, error: err };
    }

    if (setProperties && typeof setProperties === "function") {
      setProperties(data);
    }

    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
